import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleNavigate } from "../hooks/handleNavigate";
import ParagraphSelector from "../features/assignment/components/common/ParagraphSelector";
import SectionSelector from "../features/assignment/components/common/SectionSelector";

import {
  fetchParagraphList,
  fetchSectionList,
  setParagraph,
  setSection,
} from "../features/assignment/assignmentSlice";
import TopBar from "../features/assignment/components/widgets/TopBar";
import SectionPage from "../features/assignment/components/common/SectionPage";

const AssignmentPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.student);
  const { paragraphList, sectionList, assignment } = useSelector(
    (state) => {
      const assignment = state.assignment;

      // make paragraphList's first element to last,
      // when assignment.assignment.is_retry is true

      if (assignment?.assignment?.is_retry) {
        // Avoid mutating the original array since it may be frozen or non-extensible.
        const paragraphList = assignment.paragraphList;
        const rotatedParagraphList = paragraphList.length > 0
          ? [...paragraphList.slice(1), paragraphList[0]]
          : [];

        return {
          ...assignment,
          paragraphList: rotatedParagraphList,
        };
      }

      return assignment;
    }
  );
  const [selectedParagraph, setSelectedParagraph] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const assignmentId = queryParams.get("id");

    if (assignmentId) {
      try {
        dispatch(fetchParagraphList(assignmentId));
      } catch (error) {
        alert("잘못된 URL입니다.");
      }
    } else {
      alert("잘못된 URL입니다.");
    }
  }, [dispatch]);

  useEffect(() => {
    if (!isAuthenticated) {
      handleNavigate({ url: "/home", params: {}, navigate });
    }
  });

  const handleSelectParagraph = (paragraph) => {
    setSelectedParagraph(paragraph);
  };

  const handleCompleteParagraphSelection = () => {
    if (!selectedParagraph) {
      alert("지문을 선택해주세요.");
      return;
    }
    dispatch(setParagraph(selectedParagraph));
    dispatch(fetchSectionList(selectedParagraph.id));
    setCurrentStep(2);
  };

  const backToParagraphSelection = () => {
    setCurrentStep(1);
  };

  const handleSelectSection = (section) => {
    setSelectedSection(section);
  };

  const handleCompleteSectionSelection = () => {
    if (!selectedSection) {
      alert("섹션을 선택해주세요.");
      return;
    }
    dispatch(setSection(selectedSection));
    setSelectedSection(null);
    setCurrentStep(3);
  };

  const renderContent = () => {
    if (currentStep === 1) {
      return (
        <ParagraphSelector
          paragraphList={paragraphList}
          selectedParagraph={selectedParagraph}
          setSelectedParagraph={handleSelectParagraph}
          handleNext={handleCompleteParagraphSelection}
        />
      );
    } else if (currentStep === 2) {
      return (
        <SectionSelector
          sectionList={sectionList}
          selectedSection={selectedSection}
          setSelectedSection={handleSelectSection}
          handleNext={handleCompleteSectionSelection}
          handleBefore={backToParagraphSelection}
        />
      );
    } else {
      return <SectionPage setCurrentStep={setCurrentStep} />;
    }
  };

  return (
    <div
      style={{
        fontFamily: '"Noto Sans KR", sans-serif',
        backgroundColor: "#F6F8FA",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        userSelect: "none",
      }}
      onContextMenu={(e) => {
        e.preventDefault();
      }}
    >
      <div
        style={{
          padding: "0px 40px",
          height: "calc(100vh - 70px)",
        }}
      >
        <TopBar currentStep={currentStep} setCurrentStep={setCurrentStep} />
        {renderContent()}
      </div>
    </div>
  );
};

export default AssignmentPage;
